const WalletIcon = () => (
  <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="wallet-icon-grad" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(5 15.5) rotate(-46.3322) scale(15.2069 12.0437)">
        <stop stopColor="var(--s247-icon-start, #E65845)"/>
        <stop offset="1" stopColor="var(--s247-icon-end, #CE4D7B)"/>
      </radialGradient>
    </defs>
    <path fillRule="evenodd" clipRule="evenodd" d="M3.02739 2.41H3.01719C2.94552 2.4237 2.8746 2.43989 2.80451 2.45849C1.02178 2.9059 0.5 4.52167 0.5 5.5V6.6287C0.484601 6.75123 0.476699 6.87521 0.476562 7V16C0.477431 16.7954 0.79378 17.5579 1.3562 18.1204C1.91862 18.6828 2.68118 18.9991 3.47656 19H18.4766C19.2719 18.9991 20.0345 18.6828 20.5969 18.1204C21.1593 17.5579 21.4757 16.7954 21.4766 16V7C21.4757 6.20461 21.1593 5.44206 20.5969 4.87963C20.0345 4.31721 19.2719 4.00086 18.4766 4H6.49718C5.70624 3.99772 5.62024 3.03812 6.29286 2.875H18.4766C18.6518 2.87491 18.8268 2.88603 19.0006 2.90828C18.9417 2.49473 18.7997 2.0974 18.583 1.74024C18.3664 1.38308 18.0797 1.07348 17.7402 0.830123C17.4007 0.586761 17.0154 0.414673 16.6076 0.324234C16.1998 0.233796 15.7779 0.226879 15.3673 0.303902L3.51949 2.32664C3.35672 2.35156 3.19216 2.37925 3.02739 2.41ZM15.4166 12.7472C15.6633 12.912 15.9533 13 16.25 13C16.6478 13 17.0294 12.842 17.3107 12.5607C17.592 12.2794 17.75 11.8978 17.75 11.5C17.75 11.2033 17.662 10.9133 17.4972 10.6666C17.3324 10.42 17.0981 10.2277 16.824 10.1142C16.5499 10.0006 16.2483 9.97094 15.9574 10.0288C15.6664 10.0867 15.3991 10.2296 15.1893 10.4393C14.9796 10.6491 14.8367 10.9164 14.7788 11.2074C14.7209 11.4983 14.7506 11.7999 14.8642 12.074C14.9777 12.3481 15.17 12.5824 15.4166 12.7472Z" fill="url(#wallet-icon-grad)"/>
  </svg>
);
import Section from 'Components/Section';
import { useTranslation } from 'react-i18next';
import './index.scss';

import { useSelector } from 'react-redux';
import { c2cOrderPaymentSelectors } from 'Stores/c2c-order-payment';
import SelectPaymentKorea from './SelectPaymentKorea';
import SelectPaymentVN from './SelectPaymentVN';

const SelectPaymentMethod = () => {
  const { t } = useTranslation();
  const { isGlobal, globalDirection } = useSelector(
    c2cOrderPaymentSelectors.get
  );

  return (
    <Section
      className="select-address"
      title={t('order_bill_select_payment_method')}
      icon={<WalletIcon />}
    >
      {isGlobal && globalDirection === 'inbound' ? (
        <SelectPaymentKorea />
      ) : (
        <SelectPaymentVN />
      )}
    </Section>
  );
};

export default SelectPaymentMethod;
